import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('100Incharge')
export class InchargeEntity {  
  @PrimaryGeneratedColumn("increment",{name:'ID'})
  Id:number;
  @Column("varchar",{
    nullable:true,
    length:100,
    name:'BoothNo'
  })
  BoothNo:string;
  @Column("varchar",{
    nullable:true,
    length:100,
    name:'SerialNo'
  })
  SerialNo:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"HNo"
  })
  HNo:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"FirstName"
  })
  FirstName:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"Surname"
  })
  Surname:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"FN_TG"
  })
  FNTG:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"SN_TG"
  })
  SNTG:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"FH"
  })
  FH:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"FH Name"
  })
  FHName:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"Voter_ID"
  })
  VoterID:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"GENDER"
  })
  GENDER:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"AGE"
  })
  AGE:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"DOB"
  })
  DOB:string;
  @Column("int",{
    nullable:true,
    name:"VillageID"
  })
  VillageID:number;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"Caste"
  })
  Caste:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"Local / Non Local"
  })
  LocalNonLocal:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"NL_Remarks"
  })
  NL_Remarks:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"MOBILE_NO"
  })
  MOBILE_NO:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"RequestedSchemes"
  })
  RequestedSchemes:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"Party"
  })
  Party:string;
  @Column("varchar",{
    nullable: true,
    length:100,
    name:"Remarks"
  })
  Remarks:string;
  @Column("int",{
    nullable:true,
    name:"FamilyCount"
  })
  FamilyCount:number;
  @Column("int",{
    nullable:true,
    name:"InchargeUserid"
  })
  InchargeUserid:number;
  @Column("date",{
    nullable:true,
    name:"UpdatedDate"
  })
  UpdatedDate:string;
  @Column("varchar",{
    nullable: false,
    length:1000,
    name:"UpdatedBy"
  })
  UpdatedBy:string;  
  @Column("int",{
    nullable:true,
    name:"status"
  })
  status:number;
  @Column("varchar",{
    nullable: true,
    length:1000,
    name:"ImageLocation"
  })
  ImageLocation:string;  
  @Column("varchar",{
    nullable: true,
    length:1000,
    name:"GeoLocation"
  })
  GeoLocation:string;   
  @Column("int",{
    default:0,
    name:"IsHOH"
  })
  IsHOH:number;
  
}